<template>
    <div>
        <div class="banner">
        <Container>
            <CallToAction :illustration="require('@/assets/images/people-working-together-2.svg')"
                        title="Pronto para <br/>o próximo <br/>passo?"
                        alt="Pronto para o próximo passo?"
                        offborder
                        smalltext>
            <template v-slot:above>
                <div class="banner__logo">
                <img src="@/assets/icons/magor.svg"
                    title="Magor"
                    alt="Magor">
                </div>
            </template>
            <template v-slot:bellow>
                <div class="banner__actions">
                <ButtonBox :to="{ name: 'contato' }">
                  Fale conosco
                </ButtonBox>

                <ButtonBox outline href="tel:+551136246424">
                  Ligue 11 3624 6424
                </ButtonBox>
                </div>
            </template>
            </CallToAction>
        </Container>
        </div>
    </div>
</template>

<script>
import Container from '@/components/Container'
import CallToAction from '@/components/CallToAction'
import ButtonBox from '@/components/ButtonBox'

export default {
    name: 'bannersobre',
    components: {
        Container,
        CallToAction,
        ButtonBox,
    }
}
</script>

<style lang="scss" scoped>
.banner {
  // overflow: hidden;
  &__logo {
    margin-bottom: 2rem;
    img {
      width: 14rem;
      height: auto;
    }
  }
  &__actions {
    *:first-child {
      margin-bottom: 2rem;
    }
  }
}


</style>
